import { CREATORS as CREATORS_LOGO, DELEGATES as DELEGATES_LOGO } from '../MainPage/consts';

const PATH = '/img/post-realize/';

const BANNER = {
    title: [
        [
            { text: '8&minus;12 июня ', align: 'left', insert: PATH+'banner/title-img.jpg' },
            { text: 'в&nbsp;Сочи прошёл', align: 'right' },
            { text: 'South HUB&rsquo;24', align: 'left' }
        ], [
            { text: '8&minus;12 июня ', align: 'left', insert: PATH+'banner/title-img.jpg' },
            { text: 'в Сочи', align: 'left' },
            { text: 'прошёл', align: 'right' },
            { text: 'South HUB&rsquo;24', align: 'left' }
        ]
    ],
    text: 'Читайте ниже, как прошел третий кэмп для С-level'
}

const VIDEO = {
    launch: 'youtube',
    src: 'https://www.youtube.com/watch?v=111vJ_404SU',
    poster: PATH+'video/poster.jpg',
    isMuted: false,
}

const ANNUAL_CAMP = {
    text: 
        'South HUB&rsquo;24 &mdash; ежегодный кэмп для '+
        '<nobr>C-level</nobr> в IT с акцентом <nobr>на work-life</nobr> '+
        'balance. В 2024 году <nobr>на кэмпе</nobr> '+
        'прошла конференция <nobr>с участием</nobr> '+
        '<nobr>23 спикеров</nobr> <nobr>из знаковых</nobr> '+
        '<nobr>tech-компаний</nobr> страны',
    images: [
        { src: PATH+'annual-camp/img-1.jpg', margin: [230, 172] },
        { src: PATH+'annual-camp/img-2.jpg', margin: [920, 172] },
        { src: PATH+'annual-camp/img-3.jpg', margin: [0, 0] },
    ],
    footnote:
        'Помимо деловой программы были организованы '+
        'неформальные активности&nbsp;&mdash; бизнес-игры, '+
        'воркшопы, дискуссионные клубы, peer to&nbsp;peer '+
        'и&nbsp;многое другое.'
}

const HIGHLIGHTS = {
    title: [
        [
            { text: 'Хайлайты', align: 'right', insert: PATH+'highlights/title-img.jpg' },
            { text: 'South HUB&rsquo;24', align: 'left' },
        ], [
            { text: 'Хайлайты', align: 'right', insert: PATH+'highlights/title-img.jpg' },
            { text: 'South HUB&rsquo;24', align: 'left' },
        ]
    ],
    footnote:
        'Третий кэмп объединил более 400 '+
        'участников&nbsp;&mdash; руководителей среднего звена '+
        'и&nbsp;топ-менеджеров, которые занимаются '+
        'разработкой&nbsp;ПО, создают цифровые '+
        'продукты, которые драйвят развитие бизнеса '+
        'и&nbsp;IT-индустрии в&nbsp;целом. Быть частью такого '+
        'движения&nbsp;&mdash; вызов и&nbsp;гордость для нас.',
    accordion: [
        {
            title: '456 участников C-level',
            img: PATH+'highlights/accordion-1.webp',
        },
        {
            title: '148 участников Family-трека',
            img: PATH+'highlights/accordion-2.webp',
        },
        {
            title: '23&nbsp;спикера конференции ',
            img: PATH+'highlights/accordion-3.webp',
        },
        {
            title: '8&nbsp;партнёров-создателей кэмпа',
            img: PATH+'highlights/accordion-4.webp',
        },
        {
            title: '4&nbsp;спортивных турнира и&nbsp;масса полезных активностей',
            img: PATH+'highlights/accordion-5.webp',
        },
        {
            title: 'Выступление Найка Борзова на&nbsp;вечеринке открытия кэмпа',
            img: PATH+'highlights/accordion-6.webp',
        },
    ]
}

const CONFERENCE_REPORTS = {
    title: [
        [
            { text: 'Доклады', align: 'left' },
            { text: 'конференции', align: 'right', insert: PATH+'conference-reports/title-img.jpg' },
        ], [
            { text: 'Доклады', align: 'left', insert: PATH+'conference-reports/title-img.jpg' },
            { text: 'South HUB&rsquo;24', align: 'left' },
        ]
    ],
    cards: {
        items: [
            {
                image: PATH+'conference-reports/cards/card-1.jpg',
                title: 'Сложности масштабирования: от&nbsp;стартапа до&nbsp;экосистемы',
                footnote: 'Анатолий Панов, технический директор Авито Товары',
                link: 'https://youtu.be/HQyFNb4LXyg?si=XkdOjjZH-A2xHRwd',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-2.jpg',
                title: 'Школа выживания технического руководителя в&nbsp;суровом мире бизнеса',
                footnote: 'Александр Ложечкин, CIO, член правления, Райффайзен Банк',
                link: 'https://youtu.be/1Ar_4hA48mg?si=NGvfCyoNxvmTrNUX',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-3.jpg',
                title: 'GenAI: от&nbsp;цифровых модальностей до&nbsp;физического мира',
                footnote: 'Семён Будённый, начальник управления развития перспективных технологий AI, Sber&nbsp;AI',
                link: 'https://www.youtube.com/watch?v=xPUEMKa1mUQ',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-4.jpg',
                title: 'Как устойчиво расти самому, команде и&nbsp;бизнесу, когда планка растёт',
                footnote: 'Олег Коверзнев, CEO, Yandex Cloud',
                link: 'https://youtu.be/c0XO987z2OI?si=fXSuLr91CPzScnDH',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-5.jpg',
                title: 'Нужен&nbsp;ли руководитель для СЕО?',
                footnote: 'Роман Маресов, руководитель <nobr>e-com-сервисов</nobr> Яндекса',
                link: 'https://youtu.be/eFfyv6kKaNg?si=6BJ5T8qf0b06mLj0',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-6.jpg',
                title: 'Распаковка Альфа-Банка: цифровой банкинг, люди и&nbsp;технологии',
                footnote: 'Дамир Баттулин, директор по&nbsp;развитию цифровых каналов, старший <nobr>вице-президент</nobr> <nobr>Альфа-Банка</nobr>',
                link: 'https://youtu.be/zX1JiAKSoJc?si=pHwV85oIKAEWVpMz',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-7.jpg',
                title: 'Карьера CEO: из&nbsp;классической коммерции в&nbsp;технологичную онлайн-платформу',
                footnote: 'Максим Гришаков, CEO, Lamoda',
                link: 'https://youtu.be/tPHIphADc30?si=Td6WDcwdla6HasOf',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-8.jpg',
                title: 'Идеальный СТО: почему им&nbsp;нельзя стать',
                footnote: 'Сергей Ляджин, технический директор ВКонтакте, VK',
                link: 'https://youtu.be/zInHR39qJrQ?si=0WL1xmYo1I5Oe0ud',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-9.jpg',
                title: 'Мечта вращать планету: развилки при построении экосистемы на&nbsp;высоких скоростях бизнеса',
                footnote: 'Ксения Позднякова, директор по&nbsp;финансовой и&nbsp;<nobr>ИТ-трансформации</nobr> группы Самолет',
                link: 'https://youtu.be/4n5bdNurzPc?si=_2Mcc4Undz66zb5w',
                linkIcon: 'play',
                minHeight: 640
            },
            {
                image: PATH+'conference-reports/cards/card-10.jpg',
                title: 'Путь МТС от&nbsp;оператора связи к&nbsp;цифровой экосистеме',
                footnote: 'Максим Лаптев, <nobr>вице-президент</nobr> по&nbsp;цифровым продуктам, МТС',
                link: 'https://youtu.be/ggeR60HL-tw?si=21Jy87-ZBZF_Q4AY',
                linkIcon: 'play',
                minHeight: 640
            }
        ],
        moreLink: {
            href: 'https://www.youtube.com/playlist?list=PL1GqRF3TOpZBQABpsk3jW6NGzf6m0yi0P',
            text: 'Записи докладов конференции смотрите на&nbsp;Youtube-канале South HUB',
            icon: 'blank',
            target: '_blank'
        }
    }
}

const VILLAGE_CAMP = {
    title: [
        [
            { text: 'Деревня', align: 'left', insert: PATH+'village-camp/title-img.jpg' },
            { text: '<nobr>       </nobr>кэмпа', align: 'left' },
        ], [
            { text: 'Деревня', align: 'left' },
            { text: 'кэмпа', align: 'right', insert: PATH+'village-camp/title-img.jpg' },
        ]
    ],
    text: 
        'Чтобы South HUB&rsquo;24 получился '+
        'насыщенным <nobr>и глубоким</nobr>, вокруг '+
        'него объединились <nobr>8 tech-компаний</nobr> '+
        '<nobr>с ярким</nobr> видением <nobr>и опытом</nobr>: Авито, '+
        '<nobr>Альфа-Банк</nobr>, МТС, Сбер, Самолет, '+
        '<nobr>Яндекс Go</nobr>, <nobr>Yandex Cloud</nobr> <nobr>и VK</nobr>',
    images: [
        { src: PATH+'village-camp/img-1.jpg', margin: [690, 240] },
        { src: PATH+'village-camp/img-2.jpg', margin: [0, 240] },
        { src: PATH+'village-camp/img-3.jpg', margin: [920, 0] },
    ],
    footnote:
        'Создатели наполнили программу '+
        'активностями на&nbsp;своих бренд-виллах. '+
        'Это отдельные домики с&nbsp;оригинальной '+
        'атмосферой, атрибутами, событиями, '+
        'а&nbsp;ещё&nbsp;&mdash; неповторимыми людьми.'
}

const ACTIVITIES = {
    title: [
        [
            { text: 'Активности', align: 'right' },
            { text: 'на виллах', align: 'left' },
            { text: 'создателей', align: 'right', insert: PATH+'activities/title-img.jpg' },
        ], [
            { text: 'активности', align: 'right' },
            { text: 'на бренд -', align: 'left' },
            { text: 'виллах', align: 'right', insert: PATH+'activities/title-img.jpg' },
        ]
    ],
    cards: {
        items: [
            {
                image: PATH+'activities/cards/card-1.jpg',
                title: 'Альфа-Банк',
                description: 
                    'Подтвердили свой вижн&nbsp;&mdash; для умных '+
                    'и&nbsp;свободных. Тут участники собирались '+
                    'на&nbsp;Growth-штурм и&nbsp;дискуссионный '+
                    'клуб о&nbsp;генеративном&nbsp;AI в&nbsp;разработке.',
                modal: {
                    id: 'activities-1',
                    slider: [
                        PATH+'activities/modal-1/img-1.jpg',
                        PATH+'activities/modal-1/img-2.jpg',
                        PATH+'activities/modal-1/img-3.jpg',
                        PATH+'activities/modal-1/img-4.jpg',
                        PATH+'activities/modal-1/img-5.jpg',
                    ],
                    logo: PATH+'activities/modal-1/logo.jpg',
                    title: 'Альфа-Банк',
                    text: 
                        'Подтвердили свой вижн&nbsp;&mdash; для умных и&nbsp;свободных. В&nbsp;вилле создателя участники собирались на&nbsp;Growth-штурм, дискуссионный клуб о&nbsp;генеративном&nbsp;AI в&nbsp;разработке и&nbsp;настольную бизнес-игру Learning Man с&nbsp;игровым полем в&nbsp;виде карты open-air фестиваля.'+
                        '<br><br>'+
                        'В&nbsp;завершении кэмпа гостей виллы ждал живой музыкальный джем-сейшн и&nbsp;любимые треки в&nbsp;исполнении кавер-группы.'
                },
                linkIcon: 'plus',
                minHeight: 620
            },
            {
                image: PATH+'activities/cards/card-2.jpg',
                title: 'Авито',
                description: 
                    'Сфокусировались на&nbsp;практической пользе '+
                    'на&nbsp;воркшопе &laquo;DIY: собери Tech стратегию '+
                    'за&nbsp;4&nbsp;часа&raquo;',
                modal: {
                    id: 'activities-2',
                    slider: [
                        PATH+'activities/modal-2/img-1.jpg',
                        PATH+'activities/modal-2/img-2.jpg',
                        PATH+'activities/modal-2/img-3.jpg',
                        PATH+'activities/modal-2/img-4.jpg',
                        PATH+'activities/modal-2/img-5.jpg',
                    ],
                    logo: PATH+'activities/modal-2/logo.jpg',
                    title: 'Авито',
                    text: 
                        'Сфокусировались на&nbsp;практической пользе. На&nbsp;воркшопе &laquo;DIY: собери Tech стратегию за&nbsp;4&nbsp;часа&raquo; выясняли, для чего нужна техническая стратегия, как её&nbsp;составлять и&nbsp;обновлять, создавали и&nbsp;питчили первые версии собственных стратегий.'+
                        '<br><br>'+
                        'А&nbsp;воркшоп по&nbsp;системному мышлению провёл гроссмейстер экстра-класса, чемпион Европы по&nbsp;быстрым шахматам Эрнесто Инаркиев.'
                },
                linkIcon: 'plus',
                minHeight: 620
            },
            {
                image: PATH+'activities/cards/card-3.jpg',
                title: 'МТС',
                description: 
                    'Отличились уникальной кальянной зоной '+
                    'в&nbsp;коллаборации с&nbsp;Самолетом для чилла и&nbsp;работы.',
                modal: {
                    id: 'activities-3',
                    slider: [
                        PATH+'activities/modal-3/img-1.jpg',
                        PATH+'activities/modal-3/img-2.jpg',
                        PATH+'activities/modal-3/img-3.jpg',
                        PATH+'activities/modal-3/img-4.jpg',
                        PATH+'activities/modal-3/img-5.jpg',
                    ],
                    logo: PATH+'activities/modal-3/logo.jpg',
                    title: 'МТС',
                    text:
                        'Отличились фирменной Монополией на&nbsp;вечере настолок и&nbsp;уникальной кальянной зоной в&nbsp;коллаборации с&nbsp;Самолетом для чилла и&nbsp;работы. В&nbsp;день закрытия на&nbsp;вечеринке в&nbsp;стиле 90-х выступала группа МТС Лейбла &laquo;внимание брусника!&raquo; с&nbsp;настоящим рок-квартирником. '+
                        '<br><br>'+
                        'Не&nbsp;обошли стороной и&nbsp;образование: провели воркшоп &laquo;Кейсы от&nbsp;МТС&raquo; и&nbsp;дискуссионный клуб &laquo;Трансформация компании&nbsp;&mdash; реальность или утопия?&raquo;'
                },
                linkIcon: 'plus',
                minHeight: 620
            },
            {
                image: PATH+'activities/cards/card-4.jpg',
                title: 'Самолет',
                description: 
                    'Предложили неожиданный подход к&nbsp;обучению agile-практикам.'+
                    '<br>'+
                    'В&nbsp;достатке было и&nbsp;развлечений: бар, казино, мини-гольф и&nbsp;поединки на&nbsp;PS5.',
                modal: {
                    id: 'activities-4',
                    slider: [
                        PATH+'activities/modal-4/img-1.jpg',
                        PATH+'activities/modal-4/img-2.jpg',
                        PATH+'activities/modal-4/img-3.jpg',
                        PATH+'activities/modal-4/img-4.jpg',
                        PATH+'activities/modal-4/img-5.jpg',
                    ],
                    logo: PATH+'activities/modal-4/logo.jpg',
                    title: 'Самолет',
                    text:
                        'Предложили неожиданный подход к&nbsp;обучению agile-практикам на&nbsp;ролевой стратегической игре &laquo;Корпорация в&nbsp;Средневековье&raquo;. Продолжили исторические твисты в&nbsp;бизнес-игре &laquo;Вокруг света за&nbsp;80&nbsp;дней&raquo; на&nbsp;базе миров Жюля Верна. О&nbsp;духе времени тоже не&nbsp;забыли&nbsp;&mdash; кстати пришёлся дискуссионный клуб &laquo;Open Source VS&nbsp;Реестр российского ПО&raquo;. '+
                        '<br><br>'+
                        'В&nbsp;достатке было и&nbsp;развлечений: бар, казино, мини-гольф и&nbsp;поединки на&nbsp;PS5.'
                },
                linkIcon: 'plus',
                minHeight: 620
            },
            {
                image: PATH+'activities/cards/card-5.jpg',
                title: 'Сбер',
                description: 
                    'Организовали дискуссионный клуб '+
                    '&laquo;Как удерживать ключевых сотрудников, когда все '+
                    'меняется&raquo;, который собрал рекордное количество участников.',
                modal: {
                    id: 'activities-5',
                    slider: [
                        PATH+'activities/modal-5/img-1.jpg',
                        PATH+'activities/modal-5/img-2.jpg',
                        PATH+'activities/modal-5/img-3.jpg',
                        PATH+'activities/modal-5/img-4.jpg',
                        PATH+'activities/modal-5/img-5.jpg',
                    ],
                    logo: PATH+'activities/modal-5/logo.jpg',
                    title: 'Сбер',
                    text: 
                        'привлекли внимание креативными событиями. Например, бизнес-игрой &laquo;Олимпик&raquo; со&nbsp;спасением судна и&nbsp;мастер-классом по&nbsp;комедийной импровизации, где участники качали актёрское мастерство и&nbsp;ораторское искусство. '+
                        '<br><br>'+
                        'Ценным стал дискуссионный клуб &laquo;Как удерживать ключевых сотрудников, когда все меняется: личные кейсы С-level&raquo;, который собрал рекордное количество участников.'
                },
                linkIcon: 'plus',
                minHeight: 620
            },
            {
                image: PATH+'activities/cards/card-6.jpg',
                title: 'Яндекс GO',
                description: 
                    'Организовали настоящий &laquo;детский&raquo; лагерь '+
                    'с&nbsp;вожатыми, стенгазетами и&nbsp;транспарантами.',
                modal: {
                    id: 'activities-6',
                    slider: [
                        PATH+'activities/modal-6/img-1.jpg',
                        PATH+'activities/modal-6/img-2.jpg',
                        PATH+'activities/modal-6/img-3.jpg',
                        PATH+'activities/modal-6/img-4.jpg',
                        PATH+'activities/modal-6/img-5.jpg',
                    ],
                    logo: PATH+'activities/modal-6/logo.jpg',
                    title: 'Яндекс GO',
                    text:
                        'Организовали настоящий &laquo;детский&raquo; лагерь со&nbsp;стенгазетами и&nbsp;транспарантами. Участники моделировали бумажные самолётики, запускали воздушных змеев и&nbsp;говорили по&nbsp;душам с&nbsp;вожатыми-экспертами. На&nbsp;воркшопе &laquo;Игра в&nbsp;стартап: баланс качества и&nbsp;скорости&raquo; говорили о&nbsp;технических решениях, их&nbsp;связи с&nbsp;развитием бизнеса, примерах неверных решений и&nbsp;этапах развития продукта. '+
                        '<br><br>'+
                        'На&nbsp;прощание устроили вечеринку с&nbsp;батутом и&nbsp;мега-дженгой и&nbsp;все дни угощали кофе, коктейлями и&nbsp;кальяном.'
                },
                linkIcon: 'plus',
                minHeight: 620
            },
            {
                image: PATH+'activities/cards/card-7.jpg',
                title: 'VK',
                description: 
                    'Провели камерный факап-найт, где участники '+
                    'делились историями провалов, травили '+
                    'зловещие байки off the record и&nbsp;лечили '+
                    'производственные душевные раны.',
                modal: {
                    id: 'activities-7',
                    slider: [
                        PATH+'activities/modal-7/img-1.jpg',
                        PATH+'activities/modal-7/img-2.jpg',
                        PATH+'activities/modal-7/img-3.jpg',
                        PATH+'activities/modal-7/img-4.jpg',
                        PATH+'activities/modal-7/img-5.jpg',
                    ],
                    logo: PATH+'activities/modal-7/logo.jpg',
                    title: 'VK',
                    text:
                        'Порадовали оригинальными форматами. Удалась DIY-вечеринка со&nbsp;сборкой ноутов на&nbsp;скорость с&nbsp;перерывами на&nbsp;шоты, плюс к&nbsp;тому&nbsp;&mdash; камерный факап-найт с&nbsp;Иваном Самсоновым, где делились историями провалов, травили зловещие байки off the record и&nbsp;лечили производственные душевные раны.'+
                        '<br><br>'+
                        'За&nbsp;прокачку профи отвечали воркшопы: Nord Star Metric, &laquo;Как из&nbsp;внутренней разработки сделать B2B-продукт&raquo; и&nbsp;&laquo;Роль СТО в&nbsp;бурно растущей команде на&nbsp;примере маркетплейса&raquo;.'
                },
                linkIcon: 'plus',
                minHeight: 620
            },
            {
                image: PATH+'activities/cards/card-8.jpg',
                title: 'Yandex Cloud и&nbsp;Яндекс 360',
                description: 
                    'Удивили воркшопом с&nbsp;единственной девушкой-'+
                    'пилотом крупного мирового чемпионата '+
                    'по&nbsp;дрифту RDS&nbsp;GP.',
                modal: {
                    id: 'activities-8',
                    slider: [
                        PATH+'activities/modal-8/img-1.jpg',
                        PATH+'activities/modal-8/img-5.jpg',
                        PATH+'activities/modal-8/img-2.jpg',
                        PATH+'activities/modal-8/img-3.jpg',
                        PATH+'activities/modal-8/img-4.jpg',
                    ],
                    logo: PATH+'activities/modal-8/logo.jpg',
                    title: 'Yandex Cloud и&nbsp;Яндекс 360',
                    text: 
                        'Удивили необычным воркшопом с&nbsp;Екатериной Набойченко, единственной девушкой-пилотом крупного мирового чемпионата по&nbsp;дрифту RDS GP. А&nbsp;еще провели дискуссионный клуб &laquo;Квиз в&nbsp;облаке, дебаты на&nbsp;земле&raquo; о&nbsp;методах измерения бизнес value, командах и&nbsp;софт-скилах. '+
                        '<br><br>'+
                        'В&nbsp;финале организовали прощальную вечеринку Tako &amp;&nbsp;Grill со&nbsp;спонтанным караоке.'
                },
                linkIcon: 'plus',
                minHeight: 620
            },
        ]
    }
}

const BALANCE_AND_SPORTS = {
    title: [
        [
            { text: 'Баланс', align: 'left', insert: PATH+'balance-and-sports/title-img.jpg' },
            { text: '<nobr>       </nobr>и спорт', align: 'left' },
        ], [
            { text: 'Баланс', align: 'left' },
            { text: 'и спорт', align: 'right', insert: PATH+'balance-and-sports/title-img.jpg' },
        ]
    ],
    cards: {
        footnote: 
            'Философия South HUB&nbsp;&mdash; это жизненный '+
            'баланс, который является фундаментом для '+
            'развития. Поэтому движение, спорт и&nbsp;релакс '+
            'стали значимой частью программы.',
        items: [
            {
                image: PATH+'balance-and-sports/cards/card-1.jpg',
                title: 'Спортивный кубок',
                description: 
                    'Стритбол от&nbsp;VK, волейбол от&nbsp;Яндекс&nbsp;Go, большой теннис от&nbsp;Yandex Cloud и&nbsp;шахматный турнир от&nbsp;Авито',
            },
            {
                image: PATH+'balance-and-sports/cards/card-2.jpg',
                title: 'Пробежки',
                description: 
                    'Утренние пробежки с&nbsp;исполнительным '+
                    'директором и&nbsp;МС по&nbsp;пауэрлифтингу Петром '+
                    'Белкиным от&nbsp;Сбера',
            },
            {
                image: PATH+'balance-and-sports/cards/card-3.jpg',
                title: 'Лекции и&nbsp;мастер-классы',
                description: 
                    'Лекции по&nbsp;биохакингу, науке сна '+
                    'и&nbsp;профилактике старения организма',
            },
            {
                image: PATH+'balance-and-sports/cards/card-4.jpg',
                title: 'Панорамный хайкинг',
                description: 
                    'Увлекательные маршруты хайкинга '+
                    'от&nbsp;Самолета, S7&nbsp;и&nbsp;Альфа-Банка и&nbsp;пивной '+
                    'хайкинг от&nbsp;МТС',
            },
            {
                image: PATH+'balance-and-sports/cards/card-5.jpg',
                title: 'Рассветные медитации',
                description: 
                    'Медитации в&nbsp;горах, практики на&nbsp;гвоздях под '+
                    'поющие чаши и&nbsp;чай от&nbsp;Сбера',
            },
        ],
        isForDarkSection: true
    }
}

const MARQUEE = {
    href: 'https://t.me/sthhb',
    lines: [
        {
            text: 'Новости и анонсы клубных встреч',
            icon: 'tg',
        },
        {
            text: 'Комьюнити IT-экспертов',
            icon: 'tg',
        }
    ]
}

const FAMILY = {
    title: [
        [
            { text: 'South HUB', align: 'left' },
            { text: 'family', align: 'left', insert: PATH+'family/title-img.jpg', insertFloat: 'left', insertPad: '<nobr>      </nobr>' },
        ], [
            { text: 'South HUB', align: 'left' },
            { text: 'family', align: 'right', insert: PATH+'family/title-img.jpg' },
        ]
    ],
    text: 
        'На кэмпе были предусмотрены '+
        'отдельные программы <nobr>для спутников</nobr> '+
        '<nobr>и детей</nobr>. <nobr>На креативном</nobr> треке '+
        '<nobr>по дизайн-мышлению</nobr> <nobr>от Альфа-Банка</nobr> '+
        'будущие <nobr>C-level</nobr> разрабатывали '+
        'прототипы банковских приложений '+
        '<nobr>и обучались</nobr> исследовательским методам',
    images: [
        { src: PATH+'family/img-1.jpg', margin: [230, 133] },
        { src: PATH+'family/img-2.jpg', margin: [920, 75] },
        { src: PATH+'family/img-3.jpg', margin: [0, 0] },
    ],
    footnote:
        'По&nbsp;итогам креативного трека дети презентовали свои решения экспертному жюри из&nbsp;Alfa Research Center и&nbsp;Семейного банка.'+
        '<br><br>'+
        'В&nbsp;программе для спутников вместе с&nbsp;экспертами Альфа-Банка гости участвовали в&nbsp;воркшопах и&nbsp;дебат-клубе по&nbsp;темам финансовой грамотности детей и&nbsp;взрослых.'
}

const BETWEEN_CAMPS = {
    title: [
        [
            { text: 'Между кэмпами —', align: 'right' },
            { text: 'клуб С-level', align: 'left', insert: PATH+'between-camps/title-img.jpg' },
        ], [
            { text: 'Между ', align: 'left', insert: PATH+'between-camps/title-img.jpg' },
            { text: 'кэмпами —', align: 'right' },
            { text: 'клуб С-level', align: 'left' },
        ]
    ],
    text: 
        'Главное, что остаётся после каждого '+
        'кэмпа — комьюнити ярких '+
        '<nobr>и амбициозных</nobr> <nobr>C-level в IT</nobr>',
    images: [
        { src: PATH+'between-camps/img-1.jpg', margin: [230, 133] },
        { src: PATH+'between-camps/img-2.jpg', margin: [920, 75] },
        { src: PATH+'between-camps/img-3.jpg', margin: [0, 0] },
    ],
    footnote:
        'Каждый месяц участники встречаются '+
        'на&nbsp;клубных встречах: ходят на&nbsp;экскурсии '+
        'в&nbsp;офисы и&nbsp;лаборатории технологических '+
        'компаний, участвуют в&nbsp;дискуссиях, '+
        'организуют спортивные активности.',
    more: {
        href: 'https://club.southhub.ru/',
        text: 'Клуб С-level',
        pos: 'left',
        theme: 'white',
        gap: 'min'
    }
}

const CREATORS = {
    title: [
        [
            { text: 'Создатели', align: 'left' },
            { text: 'South HUB&rsquo;24', align: 'right', insert: '/img/title-img-10.jpg' },
        ], [
            { text: 'Создатели ', align: 'left', insert: '/img/title-img-10.jpg' },
            { text: 'South HUB&rsquo;24', align: 'right' },
        ]
    ],
    logos: {
        list: CREATORS_LOGO,
        columns: 3,
    }
}

const DELEGATES = {
    title: [
        [
            { text: 'Делегаты', align: 'right' },
            { text: 'South HUB&rsquo;24', align: 'left', insert: '/img/title-img-delegates.jpg' },
        ], [
            { text: 'Делегаты', align: 'right', insert: '/img/title-img-delegates.jpg' },
            { text: 'South HUB&rsquo;24', align: 'left' },
        ]
    ],
    logos: {
        list: DELEGATES_LOGO,
        columns: 3,
    }
}

export {
    BANNER,
    VIDEO,
    ANNUAL_CAMP,
    HIGHLIGHTS,
    CONFERENCE_REPORTS,
    VILLAGE_CAMP,
    ACTIVITIES,
    BALANCE_AND_SPORTS,
    MARQUEE,
    FAMILY,
    BETWEEN_CAMPS,
    CREATORS,
    DELEGATES
}